import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { settingService } from "../../../services/extensions";
import AddActivityForm from "./activity-form";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Util } from "../../../services";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";
import ImportPopup from "../importpopup/importPop";
import { TriStateCheckbox } from "primereact/tristatecheckbox";

function Activity() {
  const [masterActivity, setMasterActivity] = useState([]);
  const [activityDialog, setactivityDialog] = useState(false);
  const [importDialog, setImportDialog] = useState(false);
  const dt = useRef(null);
  const [selectedActivity, setSelectedActivity] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [selectActivity, setSelectActivity] = useState([]);
  const [allActivity, setallActivity] = useState([]);

  useEffect(() => {
    getMasterActivity();
  }, []);

  const getMasterActivity = () => {
    settingService.getAllMasterActivity().then((resp) => {
      setMasterActivity(resp.data.data);
      setallActivity(resp.data.data);
    });
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };

  const addActivities = () => {
    setactivityDialog(true);
  };

  const onHide = () => {
    setactivityDialog(false);
  };

  const closeEntityDialoge = () => {
    setactivityDialog(false);
    getMasterActivity();
  };

  const NewActivityDialog = () => {
    return (
      <Dialog
        // style={{ width: "30vw" }}
        className="modal_width"
        header="Add Activity"
        visible={activityDialog}
        onHide={() => onHide()}>
        <AddActivityForm
          onClose={(e) => {
            closeEntityDialoge();
          }} />
      </Dialog>
    );
  };

  const exportExcel = () => {
    Util.exportExcel(masterActivity, "Master_Actitvities");
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "isBillable", header: "IsBillable" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    Util.exportAsPdf(exportColumns, masterActivity, "Master_Actitvities");
  };

  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const onClickDeallocation = (rowData) => {
    setImportDialog(true);
  };
  const onHideImport = () => {
    setImportDialog(false);
  };

  const OpenimportDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog"
        header="Import"
        footer={<Button label="Submit"></Button>}
        visible={importDialog}
        onHide={() => onHideImport()}>
        <ImportPopup
          onClose={(e) => {
            setImportDialog(false);
          }}
          type="legalEntity" />
      </Dialog>
    );
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button mr-2"
          onClick={() => addActivities()}
        ></Button>
        <Button
          type="button"
          label="Delete"
          icon="pi pi-trash"
          className="p-button-danger"
          disabled={disabled}
          onClick={deleteConfirm}
        ></Button>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          label="Import"
          icon="pi pi-plus"
          className="mr-2"
          onClick={() => {
            onClickDeallocation(rowData);
          }} />
        <SplitButton
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self" />
      </React.Fragment>
    );
  };

  const editActivityRowComplete = (e) => {
    let _activity = [...masterActivity];
    let { newData, index } = e;
    _activity[index] = newData;

    let param = {
      id: _activity[index].id,
      code: _activity[index].code,
      title: _activity[index].title,
      isBillable: _activity[index].isBillable,
      status: _activity[index].status,
    };

    try {
      settingService.updateMasterActivity(param).then(
        (resp) => {
          if (resp) {
            toast.success("Activity updated successfully!");
            getMasterActivity();
          }
        },
        (err) => {
          toast.error("Unable to update activity");
        }
      );
    } catch (error) {
      toast.error("Unable to update activity");
    }
  };

  const deleteActivity = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        settingService.deleteMasterActivityById(row.id).then(
          (resp) => {
            toast.success("Activity deleted successfully!");
            getMasterActivity();
          },
          (error) => { }
        );
      },
      accept: () => { },
    });
  };

  const deleteActivityByRow = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={(e) => deleteActivity(e, row)}
        ></Button>
      </React.Fragment>
    );
  };

  const codeEditor = (options) => {
    return (
      <InputText
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}
      ></InputText>
    );
  };

  const titleEditor = (options) => {
    return (
      <InputText
        value={options.value}
        onChange={(e) =>
          options.editorCallback(
            e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
          )
        }
      ></InputText>
    );
  };
  const isBillableEditor = (options) => {
    return (
      <div>
        <div className="field-checkbox m-0">
          <TriStateCheckbox value={options.value} onChange={(e) =>
            options.editorCallback(
              e.value
            )
          } />
          <label>{String(options.value)}</label>
        </div>
      </div>
    );
  };

  const statuses = [
    { label: "INACTIVE", value: 0 },
    { label: "ACTIVE", value: 1 },
    { label: "ARCHIVE", value: 4 },
  ];

  const statusEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Status"
        itemTemplate={(option) => {
          return (
            <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
          );
        }}
      />
    );
  };

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const deleteConfirm = () => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunc(),
      reject,
    });
  };

  const billable = (el) => {
    return (
      <div>
        {el.isBillable ? (
          <span style={{ marginLeft: "20px", height: "18px", color: "green" }}>Billable</span>
        ) : (
          <span style={{ marginLeft: "20px", height: "18px", color: "red" }}>Non-Billable</span>
        )}
      </div>
    );
  };

  const acceptFunc = () => {
    var activityIdList = [];
    selectedActivity.map((item, key) => {
      activityIdList[key] = item.id;
    });
    let param = {
      Ids: activityIdList,
    };
    try {
      settingService.deleteAllActivity(param).then(
        (resp) => {
          toast.success("Activity deleted");
          setSelectedActivity([]);
          getMasterActivity();
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedActivity([]);
        }
      );
    } catch (error) {
      toast.error("Unable to delete activity");
    }
  };

  const onCheckActivity = (e) => {
    setSelectedActivity(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };
  const filterActivity = (data, allActivity) => {
    setSelectActivity(data);
    let activityFilter = allActivity.filter((item) => {
      return item.code === data.code;
    });
    setMasterActivity(activityFilter);
  };
  const rightDropdownTemplate = () => {
    return (
      <React.Fragment>
        <div className="mt-3 mr-3">
          <h3>Select Activity</h3>
        </div>
        <Dropdown
          filter
          style={{ width: "250px" }}
          placeholder="Select Activity"
          optionLabel="title"
          options={allActivity}
          value={selectActivity}
          onChange={(e) => filterActivity(e.value, allActivity)}
          appendTo="self"
        ></Dropdown>
      </React.Fragment>
    );
  };

  return (
    <div>
      <Toolbar
        className="mb-2"
        left={leftToolbarTemplate}
        right={rightToolbarTemplate}
      ></Toolbar>
      <div>
        <Toolbar
          className="mb-2"
          left=""
          right={rightDropdownTemplate}
        ></Toolbar>
      </div>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={masterActivity}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            onRowEditComplete={editActivityRowComplete}
            ref={dt}
            selectionMode="checkbox"
            selection={selectedActivity}
            onSelectionChange={(e) => onCheckActivity(e)}>
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem" }}
            ></Column>
            <Column
              field="code"
              header="Code"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => codeEditor(options)}
            ></Column>
            <Column
              field="title"
              header="Title"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => titleEditor(options)}
            ></Column>
            <Column
              field="isBillable"
              header="IsBillable"
              headerStyle={{ width: "8rem" }}
              body={billable}
              sortable
              editor={(options) => isBillableEditor(options)}
            ></Column>
            <Column
              field="status"
              header="Status"
              headerStyle={{ width: "8rem" }}
              body={statusBodyTemplate}
              editor={(options) => statusEditor(options)}
              style={{ width: "20%" }}
            ></Column>
            <Column
              rowEditor
              headerStyle={{ width: "10%", minWidth: "8rem" }}
              bodyStyle={{ textAlign: "right" }}
            ></Column>
            <Column
              rowEditor
              style={{ minWidth: "8rem" }}
              exportable={false}
              body={deleteActivityByRow}
              headerStyle={{ width: "10%", minWidth: "8rem" }}
            ></Column>
          </DataTable>
        </div>
      </div>
      {OpenimportDialog()}
      {NewActivityDialog()}
    </div>
  );
}

export default Activity;